// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1Mzto","footer":"ModalInfo_footer__TatG0"};